export const WEBSITE_KPI_COUNT_FIELD_KEYS = Object.freeze([
  "currentDraftCount",
  "draftCreatedCount",
  "draftSaveCount",
  "buildStartedCount",
  "buildSucceededCount",
  "buildFailedCount",
  "buildAbandonedCount",
  "buildSuccessRateSampleCount",
  "buildFailureRateSampleCount",
  "buildAbandonmentRateSampleCount",
  "timeToFirstPreviewSampleCount",
  "timeToPublishSampleCount",
  "publicPreviewViewCount",
  "uniquePreviewedWebsiteCount",
  "uniqueLiveSiteCount",
  "liveSiteOpenCount",
  "liveSiteUpdateCount",
  "deletedWebsiteCount",
  "lastPublicPreviewAt",
  "lastLiveSiteOpenAt",
  "lastLiveSiteUpdateAt",
  "costPerActiveSitePerMonthSampleCount",
  "fallbackSubdomainAvailabilitySampleCount",
  "quoteToChargeMismatchSampleCount",
  "siteLcpMobileSampleCount",
  "siteLcpTabletSampleCount",
  "siteLcpDesktopSampleCount",
  "previewSiteLcpMobileSampleCount",
  "previewSiteLcpTabletSampleCount",
  "previewSiteLcpDesktopSampleCount",
  "liveSiteLcpMobileSampleCount",
  "liveSiteLcpTabletSampleCount",
  "liveSiteLcpDesktopSampleCount",
]);

export const WEBSITE_KPI_NULLABLE_FIELD_KEYS = Object.freeze([
  "buildSuccessRate",
  "buildFailureRate",
  "buildAbandonmentRate",
  "timeToFirstPreviewP95",
  "previewSiteLcpMobileP75",
  "previewSiteLcpTabletP75",
  "previewSiteLcpDesktopP75",
  "liveSiteLcpMobileP75",
  "liveSiteLcpTabletP75",
  "liveSiteLcpDesktopP75",
  "timeToPublishP95",
  "costPerActiveSitePerMonth",
  "siteLcpMobileP75",
  "siteLcpTabletP75",
  "siteLcpDesktopP75",
  "fallbackSubdomainAvailability",
  "quoteToChargeMismatchRate",
  "bookingApiErrorRate",
  "bookingFunnelCompletionRate",
  "customDomainSetupSuccessRate",
]);

const buildEmptyWebsiteKpis = () => ({
  ...Object.fromEntries(WEBSITE_KPI_COUNT_FIELD_KEYS.map((fieldKey) => [fieldKey, 0])),
  ...Object.fromEntries(WEBSITE_KPI_NULLABLE_FIELD_KEYS.map((fieldKey) => [fieldKey, null])),
  kpiReadiness: {},
  deletionReasonBreakdown: [],
});

export const EMPTY_WEBSITE_KPIS = Object.freeze(buildEmptyWebsiteKpis());
